/**
 * Get subdomain from URL
 *
 * Development/Staging: Uses query parameter ?subdomain=xxx
 * Production: Extracts from hostname (subdomain.m-taka.co.ke)
 */
export function getSubdomain(): string | null {
  // Always check query parameter first (for dev and staging)
  const params = new URLSearchParams(window.location.search);
  const querySubdomain = params.get('subdomain');
  if (querySubdomain) {
    return querySubdomain.toLowerCase();
  }

  // Development: try hosts file approach (*.local)
  if (import.meta.env.DEV) {
    if (window.location.hostname.endsWith('.local')) {
      return window.location.hostname.split('.')[0];
    }
    return null;
  }

  // Production: extract from hostname (*.m-taka.co.ke)
  const hostname = window.location.hostname;
  const parts = hostname.split('.');

  // Must be at least subdomain.domain.tld (3 parts)
  // Exclude www and analytics subdomains
  if (parts.length >= 3 && parts[0] !== 'www' && parts[0] !== 'analytics') {
    return parts[0];
  }

  return null;
}
